import FontFaceObserver from 'fontfaceobserver'

export const fontLoadObserver = () => {
  // Optimization for Repeat Views
  if (sessionStorage.fontsLoadedCriticalFoftPreloadPolyfill) {
    document.documentElement.className += ' fonts-stage-2'
    return
  }

  const fontOpenSansSubset = new FontFaceObserver('OpenSansSubset', {})

  Promise.all([fontOpenSansSubset.load()]).then(() => {
    document.documentElement.className += ' fonts-stage-1'
    // eslint-disable-next-line no-console
    // console.log('fontOpenSansSubset Font is available')
    const fontOpenSans300 = new FontFaceObserver('OpenSans', { weight: 300 })
    const fontOpenSans400 = new FontFaceObserver('OpenSansSubset', {})
    const fontOpenSans600 = new FontFaceObserver('OpenSansSubset', { weight: 600 })
    const fontOpenSans700 = new FontFaceObserver('OpenSansSubset', { weight: 700 })

    Promise.all([
      fontOpenSans300.load(null, 10000),
      fontOpenSans400.load(null, 10000),
      fontOpenSans600.load(null, 10000),
      fontOpenSans700.load(null, 10000),
      // eslint-disable-next-line no-console
      // console.log('fontOpenSans300-700 Font is available'),
    ]).then(() => {
      document.documentElement.className += ' fonts-stage-2'
      // Optimization for Repeat Views
      sessionStorage.fontsLoadedCriticalFoftPreloadPolyfill = true
    }, (error) => {
      // eslint-disable-next-line no-console
      // console.log(`Font is not available 300-700 + ${error}`)
    })
  }, (error) => {
    // eslint-disable-next-line no-console
    // console.log(`Font is not available subset + ${error}`)
  })
}
